import { client, getNoaWorkLog } from '../../services/api';
import type { WorkLogResponse } from '../../services/api/types.gen';

/**
 * Display names for the NOA columns that show up in the work log. Anything not
 * listed falls back to the humanized column name.
 */
export const NOA_WORK_LOG_FIELD_LABELS: Record<string, string> = {
  status: 'Status',
  physician_npi: 'Physician NPI',
  physician_first_name: 'Physician first name',
  physician_last_name: 'Physician last name',
  dcn_icn_number: 'DCN/ICN',
  claim_number: 'Claim number',
  patient_control_number: 'Patient control number',
  kx_modifier: 'KX modifier',
  kx_modifier_remarks: 'KX modifier remarks',
  sent_date: 'Sent date',
  notes: 'Notes',
  accepted_externally: 'Accepted externally',
  condition_codes: 'Condition codes',
  occurrence_codes: 'Occurrence codes',
  occurrence_spans: 'Occurrence spans',
  value_codes: 'Value codes',
  remarks: 'Remarks',
};

/** The one fetch behind every NOA work-log dialog (editor popup, NOA Manager row). */
export async function loadNoaWorkLog(noaId: string): Promise<WorkLogResponse> {
  const res = await getNoaWorkLog({
    path: { noa_id: noaId },
    client,
    // Resolves on a 4xx/5xx otherwise, and the dialog would read an error
    // as an empty log.
    throwOnError: true,
  });
  if (!res.data) throw new Error('No work log in response');
  return res.data;
}
